module.exports = __webpack_public_path__ + "static/media/bus.0eda19a6.svg";